const CONTACT_API = {

    //微信登录
    
    getWechatLoginSid: {
        url: 'login/sid',
        method: 'get',
        site: 4,
    },
    
    
    // 运营后台删除接口
    getDeleteEdit: {
        url: 'delete/content',
        method: 'get',
        site: 2,
    },
    //审核通过不通过列表接口
    columnGetReasons: {
        url: 'column/getReasons',
        method: 'get',
        site: 2,
    },
    // 个人中心的收藏的论文集的搜索
    articlesGetMyArticles: {
        url: 'article/getMyArticles',
        method: 'post',
        site: 6,
        noTrans:true
    },
    indexAddToIndex: {
        url: 'index/addToIndex',
        method: 'get',
        site: 4,
    },
    indexCancelToIndex: {
        url: 'index/cancelToIndex',
        method: 'get',
        site: 4,
    },
    
    //获取主编解读列表
    editorReadList:{
        url:'ei/read',
        method:'get',
        site:1
    },
     
    // 专家完善信息提交表单接口
    expertAuth: {
        url: 'expertAuth/toAuth',
        method: 'get',
        site: 4,
    },
    // 专家完善信息模块获取用户信息接口
    expertAuthUpdateInfo: {
        url: 'expertAuth/updateInfo',
        method: 'post',
        site: 4,
    },
    /* 论文查重 */
    getTruePaperCheck:{
        url: 'paperCheck/getTruePaperCheck',
        method: 'post',
        site: 3,
    },
    paperCheckIndexReady: {
        url: 'paperCheck/indexReady',
        method: 'get',
        site: 3,
    },
    paperCheckGetUserPrice: {
        url: 'paperCheck/getUserPrice',
        method: 'post',
        site: 3,
    },
    paperCheckAddPaperCheck:{
        url: 'paperCheck/addPaperCheck',
        method: 'post',
        site: 3,
    },
    paperCheckCheckList:{
        url: 'paperCheck/checkList',
        method: 'post',
        site: 3,
    },
    paperCheckDetailInfo:{
        url: 'paperCheck/checkInfo',
        method: 'post',
        site: 3,
    },
    paperCheckCancelCheck:{
        url:'paperCheck/cancelCheck',
        method: 'post',
        site: 3,
    },
    paperCheckStatusList:{
        url:'paperCheck/statusList',
        method: 'post',
        site: 3,
    },
    paperCheckGetGoodsTypeInfo:{
        url:'paperCheck/getGoodsTypeInfo',
        method: 'post',
        site: 3,
    },
    paperCheckfaildPaperCheck:{
        url:'paperCheck/faildPaperCheck',
        method: 'post',
        site: 3,
    },
    /**********/ 

    getDelQuestion: {
        url: 'question/removeQuestion', //个人中心-提问删除接口
        method: 'get',
        site: 3,
    },
    getColumnDelColumn: {
        url: 'column/delColumn', //个人中心-文章删除接口
        method: 'get',
        site: 2,
    },
    //个人主页模块接口
    getMyProceeding:{
        url: 'lp/myProceedings', //个人中心-论文集
        method:'get',
        site:1,
    },
    getJoinProceedingsLists: {
        url: 'lp/joinProceedingsList', //论文集列表(0：未加入，1：已加入)
        method: 'get',
        site: 1
    },
    getJoinProceedings: {
        url: 'lp/joinProceedings', //添加到论文集列表
        method: 'get',
        site: 1
    },
    getSetShareNumber: {
        url: 'lp/setShareNumber', //分享次数
        method: 'get',
        site: 1
    },
    /* 
    
    
    */
    getProceedingInformation: {
        url:'lp/proceedingInformation',//
        method: 'post',
        site: 1,
    },
    getMyfollowPaper: {
        url: 'lp/myfollowPaper',//我收藏的论文
        method: 'post',
        site: 1,
    },
    getPaperAdded: {
        url: 'lp/paperAdded', //已添加的论文集列表
        method: 'post',
        site: 1,
    },
    getAddJoinProceedings: {
        url: 'lp/joinProceedings',
        method: 'post',
        site: 1,
    },
    getDelPaperInProceedings: {
        url: 'lp/delPaperInProceedings',
        method: 'post',
        site: 1,
    },
    
    getDeleteAnswer: {
        url: 'answer/deleteAnswer', //个人中心-删除回答
        method: 'post',
        site: 3,
    },
   
    getAddProceedings: {
        url: 'lp/addProceedings', //新增论文集
        method: 'post',
        site: 1,
        noTrans:true
    },
    getDelProceedings: {
        url: 'lp/delProceedings', //删除论文集
        method: 'post',
        site: 1,
    },

    getEditProceedings: {
        url: 'lp/editProceedings', //编辑论文集
        method: 'post',
        site: 1,
        noTrans: true
    },
    
    getPreview: {
        url: 'lp/preview', //pdf预览
        method: 'get',
        site: 1
    },
    getProceedingsType: {
        url: 'lp/proceedingsType', //论文集分类列表
        method: 'get',
        site: 1
    },
    
   
    getSetPraiseEvent:{
        url: 'lp/setPraiseEvent',//论文点赞
        method: 'get',
        site: 1
    },
    getSetCollectionEvent: {
       url: 'lp/setCollectionEvent', //论文收藏
       method: 'get',
       site: 1
    },
   
    personRegisterCreate: {
        url: 'register/createInvitationCode', //生成邀请码
        method: 'get',
        site: 4
    },
    
    getPersonAllNoticType: {
        url:'person/getAllNoticType',//账户设置模块消息通知
        method:'get',
        site:4
    },
    getPersonUpdateNoticType: {
        url:'person/updateNoticType', //账户设置模块保存提交
        method:'get',
        site:4
    },
    getPersonUpdateUserPrivacy: {
        url:'person/updateUserPrivacy', //水印设置
        method:'post',
        site:4
    },
    getRegisterBindOrNot: {
        url:'register/bindOrNot', //判断是否已经绑定微信userId（用户id）
        method:'post',
        site:4
    },
    getRegisterIsBind: {
        url:'register/isBind', //判断是否已经绑定微信userId（用户id）
        method:'post',
        site:4
    },
    getRegisterVerification: {
        url:'register/verification', //手机号验证和微信解绑验证account（手机号），verifyCode（验证码），type（0：手机，1：微信），wxType （微信类型 1=微信公众号），userId（用户id）
        method:'post',
        site:4
    },
    getPersonCheckMobileExists: {
        url:'person/checkMobileExists', //更改手机号之前检查手机号是否存在
        method:'post',
        site:4
    },
    getPersonUpdateUserMobile: {
        url:'person/updateUserMobile', //用户更改手机号
        method:'post',
        site:4
    },
    getColumnChangeAllowComment: {
        url:'column/changeAllowComment', //个人主页的文章关闭评论接口
        method:'post',
        site:2
    },
    /* 专家在线-服务设置模块*/
    serviceUserinfo: {
        url: 'service/userInfo', //基本信息查询
        method: 'post',
        site: 4
    },
    updateUserInfo: {
        url: 'service/updateUserInfo', //修改基本信息
        method: 'post',
        site: 4
    },
    relatedServices: {
        url: 'service/relatedServices', //查询付费咨询，写作指导，项目申报设置
        method: 'post',
        site: 4
    },
    updateRelatedServices: {
        url: 'service/updateRelatedServices', //修改服务设置
        method: 'post',
        site: 4
    },

    personInfo: {
        url: 'person/info', //进入页面（访问他人用户）接口
        method: 'get',
        site: 4
    },
    otherpersonInfo: {
        url: 'person/info', //进入页面（访问他人用户）接口
        method: 'get',
        site: 4
    },
    personUpdateInfo: {
        url: 'person/updateInfo', //修改个人信息
        method: 'post',
        site: 4
    },
    personUpdateImg: {
        url: 'person/updateImg', //修改个人信息
        method: 'post',
        site: 4
    },
    personArts: {
        url: 'person/arts', //论文解读和阐释
        method: 'get',
        site: 4
    },
    personEssays: {
        url: 'person/essays', //专栏        
        method: 'get',
        site: 4
    }, 
    personAnswers: {
        url: 'person/answers', //回答
        method: 'get',
        site: 4
    }, 
    personQuestions: {
        url: 'person/questions', //提问
        method: 'get',
        site: 4
    }, 
    personCollection: {
        url: 'person/collection', //收藏
        method: 'get',
        site: 4
    }, 
    personFollow: {
        url: 'person/follow', //关注
        method: 'get',
        site: 4
    }, 
    personAggs: {
        url: 'person/aggs', //论文集
        method: 'get',
        site: 4
    }, 
   
    /* personBrowse: {
        url: 'person/browse', //浏览(这模块产品说去掉了)
        method: 'get',
        site: 1
    }, */
    personDealFollow:{
        url: 'person/dealFollow',//关注个人接口
        method: 'get',
        site: 4
    },
    //获取图情专栏分类
    //获取图情专栏分类->后改名业务分享
    getSpecialColumnClassify:{
        url:'column/essayClassify',
        method:'get',
        site:2
    },
    //获取图情专栏列表
    getSpectialColumnList:{
        url:'column/essayList',
        method:'get',
        site:2
    },
    //图情专栏——浏览量累计
    setSpecialColumnReadCount:{
        url:'column/setBrowseNumber',
        method:'get',
        site:2
    },
    //图情专栏——关注
    specialColumnFocusTeacher:{
        url:'column/follow',
        method:'get',
        site:2
    },
    //图情专栏——点赞
    specialColumnPraise:{
        url:'column/setPraiseEvent',
        method:'get',
        site:2
    },
    //图情专栏——收藏
    specialColumnFavor:{
        url:'column/setCollectionEvent',
        method:'get',
        site:2
    },
    //图情专栏——发布评论
    specialColumnPublishComment:{
        url:'column/publishComment',
        method:'post',
        site:2
    },
    //图情专栏——获取评论列表
    specialColumnGetComment:{
        url:'column/allDetailComment',
        method:'get',
        site:2
    },
    getAuthorList:{
        url:'column/authorRecommend',
        method:'get',
        site:2
    },
    viewGetReplies:{
        url:'column/childComment',
        method:'get',
        site:2
    },
    specialColumnDetail:{
        url:'column/detailEssay',
        method:'get',
        site:2
    },
    getHotArticles:{
        url:'column/hotEssay',
        method:'get',
        site:2
    },
    getRelevantEssay:{
        url:'column/relevantEssay',
        method:'get',
        site:2
    },
    //主编解读——发布评论
    publishComment:{
        url:'ei/publishComment',
        method:'post',
        site:1
    },
    //主编解读——获取评论列表
    getCommentList:{
        url:'ei/allDetailComment',
        method:'get',
        site:1
    },
    interpretationGetReplies:{
        url:'ei/childComment',
        method:'get',
        site:1
    },
    //获取举报类型
    getTipoffType:{
        url:'lp/reportType',
        method:'get',
        site:1
    },
    //举报评论
    tipoffComment:{
        url:'lp/report',
        method:'post',
        site:1
    },
    //删除主编解读评论
    delInterpretationComment:{
        url:'ei/delComment',
        method:'get',
        site:1,
    },
    //主编解读——详情
    getInterpretationDetail:{
        url:'ei/viewInterpretation',
        method:'get',
        site:1
    },
    //主编解读——详情页相关推荐
    getInterpretationRec:{
        url:'ei/ost',
        method:'get',
        site:1
    },
    //获取外文阐释列表
    getForeignInterpretationList:{
        url:'ja/articleList',
        method:'get',
        site:1
    },
    //主编解读——累加浏览量
    interpretationSetReadCount:{
        url:'ei/setBrowseNumber',
        method:'post',
        site:1
    },
    //主编解读——点赞、取消点赞
    interpretationSetPraise:{
        url:'ei/setPraiseEvent',
        method:'post',
        site:1
    },
    //主编解读——收藏、取消收藏
    interpretationSetCollection:{
        url:'ei/setCollectionEvent',
        method:'post',
        site:1
    },    
    //主编解读——关注学者
    interpretationFocusTeacher:{
        url:'ei/follow',
        method:'post',
        site:1
    },
    //主编解读——推荐专家
    interpretationGetRecExpert:{
        url:'ei/expert',
        method:'post',
        site:1
    },
    //获取热门解读
    getHotInterpretations:{
        url:'ei/hotInterpret',
        method:'get',
        site:1
    },
    //获取TA的解读
    getHisInterpretations:{
        url:'ei/taInterpretation',
        method:'get',
        site:1
    },
    //外文阐释——累加浏览量
    foreignInterpretationSetReadCount:{
        url:'ja/setBrowseNumber',
        method:'post',
        site:1
    },
    //外文阐释———点赞、取消点赞
    foreignInterpretationSetPraise:{
        url:'ja/setPraiseEvent',
        method:'post',
        site:1
    },
    //外文阐释———收藏、取消收藏
    foreignInterpretationSetCollection:{
        url:'ja/setCollectionEvent',
        method:'post',
        site:1
    },
    //外文阐释——关注学者
    foreignInterpretationFocusTeacher:{
        url:'ja/follow',
        method:'post',
        site:1
    },
    //获取热门阐释
    getHotForeignInterpretation:{
        url:'ja/popular',
        method:'get',
        site:1
    },

    getSourceError: {
        url:'lp/sourceError',//篇详情页的链接报错功能
        method:'get',
        site:1
    },
    
    //获取期刊列表
    getJournalList:{
        url:'lp/journal',
        method:'get',
        site:1
    },
    //获取期刊聚类
    getAcademicClasses:{
        url:'lp/getJournalGrouping',
        method:'get',
        site:1
    },
    //获取期刊检索聚类
    getAcademicSearchClasses:{
        url:'lp/getGrouping',
        method:'get',
        site:1
    },
    //搜索学术期刊
    searchAcademic:{
        url:'lp/searchByPage',
        method:'post',
        site:1
    },
    //学术期刊收藏
    AcademicCollect:{
        url:'lp/setCollectionEvent',
        method:'get',
        site:1
    },
    //获取期刊基本信息
    getJounalBasicInfo:{
        url:'lp/paperBasic',
        method:'get',
        site:1
    },
    //获取具体期刊的时间序列
    getJournalSeries:{
        url:'lp/paperYear',
        method:'get',
        site:1
    },
    //获取期刊的文章列表
    getJournalArticles:{
        url:'lp/paperList',
        method:'get',
        site:1
    },
    //获取期刊详情
    getJournalDetail:{
        url:'lp/paperDetail',
        method:'get',
        site:1
    },
    getJournalArticleRec:{
        url:'lp/ost',
        method:'get',
        site:1
    },
    //获取期刊下的主编解读
    getJournalInterpretation:{
        url:'lp/editor',
        method:'get',
        site:1
    },
    //获取期刊分析年份
    getJournalAnalysisYears:{
        url:'lp/tenYear',
        method:'get',
        site:1
    },
    //期刊分析，产出成果及被引量变化趋势，
    resultsAndQuotedTrend:{
        url:'lp/science',
        method:'get',
        site:1
    },
    //期刊分析——学者分布
    getScholarDistribute:{
        url:'lp/messageAuthor',
        method:'get',
        site:1
    },
    //期刊分析——作者合作网络
    autherCooperationNet:{
        url:'lp/journalAuthor',
        method:'get',
        site:1
    },
    //期刊分析——主要发文机构分布
    mainOrgDistribute:{
        url:'lp/messageGroup',
        method:'get',
        site:1
    },
    //期刊分析——机构合作网络
    orgCooperationNet:{
        url:'lp/journalGroup',
        method:'get',
        site:1
    },
    //期刊分析——关键词分布，
    keywordsDistribute:{
        url:'lp/keyWords',
        method:'get',
        site:1
    },
    //期刊分析——基金资助文献量
    foundSupportDocuments:{
        url:'lp/subsidize',
        method:'get',
        site:1
    },
    //期刊分析——主要参考期刊分布
    referJournalDistribute:{
        url:'lp/consultJournal',
        method:'get',
        site:1
    },
    //期刊分析——期刊共被引网络
    keyWordsCooperationNet:{
        url:'lp/journalKeyWord',
        method:'get',
        site:1
    },
    journalArticleDetail:{
        url:'lp/paperInformation',
        method:'get',
        site:1
    },
    //关联发现
    linkFind:{
        url:'ei/relation',
        method:'get',
        site:1
    },
    //新增主编解读或外文阐释
    addInterpretation:{
        url:'ei/addEditor',
        method:'post',
        site:1,
        noTrans:true
    },
    //编辑主编解读或外文阐释
    editInterpretation:{
        url:'ei/updateEditor',
        method:'post',
        site:1,
        noTrans:true
    },
    //获取编辑主编详情
    editInterpretationDetail:{
        url:'ei/lookEditor',
        method:'get',
        site:1
    },
    //获取专家列表
    getExpertsList:{
        url:'ei/eiAuthor',
        method:'get',
        site:1
    },
    //新增专栏文章
    addSpecialArticle:{
        url:'column/addColumn',
        method:'post',
        site:2,
        noTrans:true
    },
    //编辑专栏文章
    editSpecialArticle:{
        url:'column/updateColumn',
        method:'post',
        site:2,
        noTrans:true
    },
    //获取编辑专栏文章详情
    editSpecialArticleDetail:{
        url:'column/lookColumn',
        method:'get',
        site:2
    },
    //删除图情视界评论
    delViewComment:{
        url:'column/delComment',
        method:'get',
        site:2,
    },
    //获取编辑详情
    editBbsArticleDetail:{
        url:'raceEssay/detailEssay',
        method:'get',
        site:2 
    },
    getBbsArtiles:{
        url:'raceEssay/essayList',
        method:'get',
        site:2
    },
    deleteBbsArticle: {
        url: 'delete/content',
        method: 'get',
        site: 2,
    },
    editBbsArticle:{
        url:'raceEssay/updateColumn',
        method:'post',
        site: 2,
        noTrans:true
    },

    //获取图情咨询列表
    getConsultList:{
        url:'question/index',
        method:'get',
        site:3
    },
    //关注问题
    focusQuestion:{
        url:'question/questionFollow',
        method:'post',
        site:3
    },
    myFocusQuestion:{
        url:'question/followQuestion',
        method:'get',
        site:3
    },
    //热门问题
    getHotQuestions:{
        url:'question/hot',
        method:'get',
        site:3
    },
    //等待回答的问题
    waitingAnswerQuestion:{
        url:'question/waitAnswerQuestion',
        method:'get',
        site:3
    },
    //获取问题详情
    getQuestionInfo:{
        url:'question/info',
        method:'get',
        site:3
    },
    //获取问题回答
    getAnswers:{
        url:'answer/getQuestionAnswer',
        method:'get',
        site:3
    },
    //判断当前用户是否可以回答问题
    checkAnswerStatus:{
        url:'answer/checkAnswerStatus',
        method:'get',
        site:3
    },
    //回答问题
    toAnswer:{
        url:'answer/addAnswer',
        method:'post',
        site:3,
        noTrans:true
    },
    //修改回答
    updateAnswer:{
        url:'answer/updateAnswer',
        method:'post',
        site:3,
        noTrans:true
    },
    //删除回答
    delAnswer:{
        url:'answer/deleteAnswer',
        method:'post',
        site:3
    },
    //答案收藏
    collectAnswer:{
        url:'answer/dealCollection',
        method:'post',
        site:3
    },
    //答案点赞
    praiseAnswer:{
        url:'answer/dealParise',
        method:'post',
        site:3
    },
    //答案点赞
    praiseAnswerComment:{
        url:'answer/dealCommentParise',
        method:'get',
        site:3
    },
    //答案我的评论
    myAnswerComment:{
        url:'answer/myDetailComment',
        method:'get',
        site:3
    },
    //问题浏览次数累计
    questionAddBrowse:{
        url:'answer/dealBrowse',
        method:'post',
        site:3
    },
    //发表问题
    addQuestion:{
        url:'question/addQuestion',
        method:'post',
        site:3
    },
    //获取添加问题标签
    getQuestionLabels:{
        url:'question/getQuestionTopic',
        method:'get',
        site:3
    },
    //问题详情页问题推荐
    getRecQuestions:{
        url:'question/getRecommecdList',
        method:'get',
        site:3
    },
    //发布答案评论
    commentAnswer:{
        url:'answer/publishComment',
        method:'post',
        site:3
    },
    //图请咨询-编辑器上传图片
    mediaUpload:{
        url:'question/uploadQuestionImage',
        method:'post',
        site:3
    },
    //获取答案评论列表
    getAnswerComments:{
        url:'answer/allDetailComment',
        method:'get',
        site:3
    },
    getReplyComments:{
        url:'answer/childComment',
        method:'get',
        site:3
    },
    //删除答案评论
    delAnswerComment:{
        url:'answer/deleteComment',
        method:'get',
        site:3
    },
    // getIndexHotConsults:{
    //     url:'question/index',
    //     method:'get',
    //     site:3
    // },
    getAnswerDetail:{
        url:'answer/getAnswerById',
        method:'get',
        site:3
    },
    //获取写作指导的专家筛选条件
    getExpertsConditions:{
        url:'instruction/getIndexReady',
        method:'get',
        site:3
    },
    //获取写作指导的专家
    getWritingExperts:{
        url:'instruction/index',
        method:'get',
        site:3
    },
    //获取专家详情——写作指导
    getWritingExpertInfo:{
        url:'instruction/expertInfo',
        method:'get',
        site:3
    },
    //获取付费咨询的筛选条件
    getPayConsultConditions:{
        url:'consulation/getIndexReady',
        method:'get',
        site:3
    },
    //获取付费咨询专家列表
    getPayConsultExperts:{
        url:'consulation/index',
        method:'get',
        site:3
    },
    //获取付费咨询旁观问题列表
    getOutlookers:{
        url:'consulation/joinQuestionIndex',
        method:'get',
        site:3
    },
    //获取付费咨询专家详情
    getPayConsultExpertInfo:{
        url:'consulation/expertInfo',
        method:'get',
        site:3
    },
    //推荐您答
    recommendYourAnswer:{
        url:'question/recommend',
        method:'get',
        site:3
    },
    //论文评审，退修指导
    // treatiseEvaluation:{
    //     url:'instruction/addInstruction',
    //     method:'post',
    //     site:3
    // },
    //获取付费咨询的单次价格
    getPayConsultPrice:{
        url:'consulation/getExpertMoney',
        method:'get',
        site:3
    },
    //添加付费咨询
    submitPayConsult:{
        url:'consulation/addConsulation',
        method:'post',
        site:3
    },
    getOutlookerInfo:{
        url:'consulation/joinQuestionInfo',
        method:'get',
        site:3
    },
    toVoteAnalysis:{
        url:'contribution/analysis',
        method:'post',
        site:3
    },
    getVoteAnalysisDetail:{
        url:'contribution/analysisInfo',
        method:'post',
        site:3
    },
    getVoteExperts:{
        url:'instruction/analysisExpert',
        method:'get',
        site:3
    },
    getOutlookerQuestionDetail:{
        url:'consulation/joinQuestionInfo',
        method:'get',
        site:3
    },

    setAnswerShareCount:{
        url:'answer/dealShare',
        method:'get',
        site:3
    },

    // getIndexHotArticles:{
    //     url:'column/hotArticle',
    //     method:'get',
    //     site:2
    // },
    // 论文发现模块接口
    getHotRecommend:{//热门推荐（不好使暂时）
        url: 'lp/hotRecommend',
        method: 'get',
        site: 1
    },
    getMyCollection: { //我的收藏
        url: 'lp/myCollection',
        method: 'get',
        site: 1
    },
    //通过论文集发现论文// http://192.168.1.131:9520/ja/lp/collectionDiscoveryPaper?pageNow=1&type=0&sort=1
    getCollectionDiscoveryPaper: { 
        url: 'lp/collectionDiscoveryPaper',
        method: 'get',
        site: 1
    },
    //通过主题发现论文// http://192.168.1.131:9520/ja/lp/themeDiscoveryPaper?keyword=A
    getThemeDiscoveryPaper: {
        url: 'lp/themeDiscoveryPaper',
        method: 'get',
        site: 1
    },
    // 通过主题发现论文的（分类下拉框）
    getAllType:{
        url: 'lp/allType',
        method: 'get',
        site: 1
    },
    //通过主题发现论文(按字母排序分类)
    getInitialsList: {
        url: 'lp/initialsList',
        method: 'get',
        site: 1
    },
    // 我的关注下面的（主题）
    getTheme: {
        url: 'lp/theme',
        method: 'get',
        site: 1
    }, 
    // 我的关注下面的（论文集）
    getProceedings: {
        url: 'lp/proceedings',
        method: 'get',
        site: 1
    },
    //我的关注的论文列表
    getFollowPaperList: {
        url: 'lp/followPaperList', //pageNow，classify（0：主题，1：论文集），type（0：最新，1：最热）
        method: 'get',
        site: 1
    },
    //关注论文集
    getFollow: {
        url: 'lp/follow', //resId，resUserId，flag:（0关注，1取消关注）type=1
        method: 'get',
        site: 1
    },
    //篇详情
    getPaperInformation: {
        url: 'lp/paperInformation', //artiId
        method: 'get',
        site: 1
    },
    // 篇详情页-发布推荐
    getAddRecommend: {
        url: 'lp/addRecommend', //ratings（推荐理由），resId（论文id）
        method: 'get',
        site: 1
    },
    // 篇详情页-推荐列表
    getRecommendList: {
        url: 'lp/recommendList', //pageNow（当前页），artiId（论文id）
        method: 'get',
        site: 1
    },
    //主题详情页-主题结构
    getThemeStructure: {
        url: 'lp/themeStructure', //topicId（主题id）
        method: 'get',
        site: 1
    },
    //主题详情页
    getThemeDetail: {
        url: 'lp/themeDetail', //topicName
        method: 'get',
        site: 1
    },
    //主题详情页-分类模块
    getTopicModule: {
        url: 'lp/topicModule', //pageNow（当前页） moduleType(0:论文1:专家解读2:外文阐释3:图情视界4:问答) topicName（ 主题名称）
        method: 'get',
        site: 1
    },
   
    //热门主题
    getHotTopics: {
        url: 'lp/hotTopics', //pageNow
        method: 'get',
        site: 1
    },
    //栾鹏的热门主题接口
    getTopicsHot: {
        url: 'topic/hot', //pageNow
        method: 'post',
        site: 5,
        noTrans:true
    },
    //热门论文集
    getHotProceedings: {
        url: 'lp/hotProceedings', //pageNow
        method: 'get',
        site: 1
    },
    //论文集详情页
    getCollectionDetails: {
        url: 'lp/collectionDetails', //aggId（论文集id），pageNow，type（0：默认排序，0：时间排序，1：热度排序）
        method: 'get',
        site: 1
    },
    
    //收录此论文的论文集
    getCollectedPapers: {
        url: 'lp/collectedPapers', //artiId
        method: 'get',
        site: 1
    },
    
    //论文发现的首页（热门推荐/精彩推荐）
    getLPHotArticles: {
        url: 'lp/hotArticles',
        method: 'get',
        site:1
    },
    //论文发现搜索
    
    getLPsearchByPage: {
        url: 'lp/searchByPage',
        method: 'get',
        site: 1
    },
   
   
    //获取首页热门推荐
    getIndexHot:{
        url:'index/hot',
        method: 'get',
        site: 4
    },
    //获取首页我的关注
    getIndexFollow:{
        url:'index/follow',
        method:'get',
        site:4
    },
    //获取作者或专家的信息
    getAuthorInfo:{
        url:'ei/userInformation',
        method:'get',
        site:1
    },
    //获取首页轮播图
    getBannerPics:{
        url:'index/index',
        method:'get',
        site:4
    },
    //首页热门主题词
    getIndexHotTopics:{
        url:'index/hotTopic',
        method:'get',
        site:4
    },
    getHotTopicNew: {
        url: 'lp/getHotTopic',
        method: 'get',
        site: 1
    },
    //首页热门论文集
    getIndexHotAggs:{
        url:'index/hotAgg',
        method:'get',
        site:4
    },
    //搜索主题
    searchTopic:{
        url:'topic/page',
        method:'post',
        site:5,
        noTrans:true
    },
    //搜索论文集
    searchTreatiseCollection:{
        url:'agg/page',
        method:'post',
        site:5,
        noTrans:true
    },
    //搜索专家解读、外文阐释
    searchInterpretation:{
        url:'interpretation/page',
        method:'post',
        site:5,
        noTrans:true
    },
    //搜索图情视界(专栏文章)
    searchSpecialColumn:{
        url:'essay/page',
        method:'post',
        site:5,
        noTrans:true
    },
    //搜索问答
    searchConsult:{
        url:'question/page',
        method:'post',
        site:5,
        noTrans:true
    },
    //搜索用户
    searchUser:{
        url:'pms/user/page',
        method:'post',
        site:5,
        noTrans:true
    },
    // 搜索（数量）
    searchCommon:{
        url:'common/agg',
        method:'get',
        site:5,
    },
    //用户登录获取签名
    accountVerifyGetSign:{
        url:'verify/getSign',
        method:'post',
        site:4
    },
    //获取验证码
    accountGetVerifyCode:{
        url:'verify/sendCode',
        method:'post',
        site:4
    },
    //验证code
    accountGoVerify:{
        url:'verify/authCode.do',
        method:'post',
        site:4
    },
    accountVerifyPhoneCode:{
        url:'verify/phoneCode',
        method:'post',
        site:4
    },
    //邀请登录
    goInviteLogin:{
        url:'register/registerUser',
        method:'post',
        site:4
    },

    userRegister:{
        url:'register/registerUser',
        method:'post',
        site:4
    },
    //获取当前(登录人的)用户信息
    getUserInfo:{
        url:'register/userInfo',
        method:'get',
        site:4
    },
    
    //获取关联发现结果
    getLinkFindResult:{
        url:'getSearch',
        method:'get',
        site:5
    },
    //获取关联发现结果
    getLinkFindRec:{
        url:'getNodesLike',
        method:'post',
        site:5
    },



    //发布专家解读，获取标题列表
    getInterpretationTitles:{
        url:'ei/paperMatching',
        method:'get',
        site:1
    },
    //专家解读根据所选标题获取相关信息
    getInterpretationAttrs:{
        url:'ei/lookJournal',
        method:'get',
        site:1
    },
    //自动推荐主题词
    getRecTopics:{
        url:'ei/getTopic',
        method:'get',
        site:1
    },
    //获取待审核的图情视界文章
    getUncheckedView:{
        url:'column/columnAudit',
        site:2,
        method:'get'
    },
    //获取待审核的专家解读文章
    getUncheckedInterpretation:{
        url:'ei/paperAudit',
        site:1,
        method:'get'
    },
    //获取活动列表
    getActionList:{
        url:'column/eventList',
        site:2,
        method:'get',
    },
    //新增活动通知
    addAction:{
        url:'column/addEvent',
        site:2,
        method:'post',
        noTrans:true
    },
    //编辑活动通知
    editAction:{
        url:'column/editEvent',
        site:2,
        method:'post',
        noTrans:true
    },
    //获取活动详情
    getActionDetail:{
        url:'column/goEvent',
        site:2,
        method:'get'
    },
    //获取最新活动
    getLastestActives:{
        url:'column/newEvent',
        site:2,
        method:'get'
    },
    getNewActives:{
        url:'column/recentNews',
        site:2,
        method:'get'
    },


    //付费咨询
    pay_get_urgent_type:{
        url:'expert/getIndexReady',
        site:3,
        method:'get'
    },
    pay_get_expert_list:{
        url:'expert/expertList',
        site:3,
        method:'get'
    },
    pay_get_expert_info:{
        url:'expert/expertInfo',
        site:3,
        method:'get'
    },
    pay_add_service:{
        url:'expert/addExpertService',
        site:3,
        method:'post'
    },
    // pay_get_new_order:{
    //     url:'scc/shopCart/payShopGoods',
    //     site:3,
    //     method:'get'
    // },
    //项目申报 获取项目级别
    get_project_grade:{
        url:'expert/getIndexReady',
        site:3,
        method:'get'
    },
    //订单处理
    order_get_cancel:{
        url:'expert/userCancelExpertService',
        site:3,
        method:'post'
    },
    order_get_list:{
        url:'expert/listExpertService',
        site:3,
        method:'get'
    },
    // order_reject:{
    //     url:'expert/confirmExpertService',
    //     site:3,
    //     method:'get'
    // },
    order_get_detail:{
        url:'expert/getExpertServiceInfo',
        site:3,
        method:'get'
    },
    order_expert_deal:{
        url:'expert/confirmExpertService',
        site:3,
        method:'get'
    },
    order_expert_reply:{
        url:'expert/answerExpertService',
        site:3,
        method:'post'
    },
    order_cancel:{
        url:'expert/userCancelExpertService',
        site:3,
        method:'get'
    },
    order_auto_Cancel:{
        url:'expert/cancelOutPayTime',
        site:3,
        method:'get'
    },
    order_getwxewm:{
        url:'wx/unifiedorder/',
        site:0,
        needJoin:true,
        method:'get',
        other:'/2/NATIVE'
    },
    order_checkpay:{
        url:'wx/orderQuery/',
        site:0,
        needJoin:true,
        method:'get',
        other:'/2'
    },
    //用户评价
    order_user_rate:{
        url:'expert/addExpertServiceRating',
        site:3,
        method:'post'
    },
    //专家回复评价
    order_expert_reply_rate:{
        url:'expert/replyExpertServiceRating',
        site:3,
        method:'post'
    },
    //余额查询
    wallet_last_money:{
        url:'amount/amount/userAmount',
        site:0,
        method:'get'
    },
    //收支列表
    wallet_output_input_list:{
        url:'amount/amount/listAmount',
        site:0,
        method:'get'
    },
    wallet_tixian:{
        url:'amount/amount/extractMoney',
        site:0,
        method:'post'
    },
    wallet_order_detail:{
        url:'amount/amount/amountInfo',
        site:0,
        method:'get'
    },
    //获取旁观问题列表
    get_outlook_ques:{
        url:'expert/listPublicExpertService',
        site:3,
        method:'get'
    },
    //发起围观，生成围观订单
    start_outlook_order:{
        url:'expert/joinPublicExpertService',
        site:3,
        method:'post'
    },
    //获取围观详情
    get_outlook_detail:{
        url:'expert/getPublicExpertServiceInfo',
        site:3,
        method:'get'
    },


    //问答举报
    consultTipOff:{
        url:'answer/addCommentTipOffs',
        site:3,
        method:'post'
    },

    getPersoanlUserGetGroup:{
        url:'user/getGroup',//模糊查询结构(groupName)
        method:'get',
        site:6
    },
    getOrgList:{
        url:'expert/groupList',
        method:'get',
        site:6
    },
    //获取配置信息列表
    getSeetingFields:{
        url:'expert/informationDeploy',
        method:'get',
        site:6
    },
    //获取IP与机构
    getIP:{
        url:'user/ipGroup',
        method:'get',
        site:6
    },
    //检查用户身份
    checkUserIndentify:{
        url:'user/getUserGroup',
        method:'get',
        site:6
    },
    perfectInfo:{
        url:'user/perfectInformation',
        method:'post',
        site:6,
        noTrans:true
    },


    //后台获取期刊
    admin_get_journals:{
        url:'recommendation/journals',
        method:'get',
        site:5,
    },
    admin_get_recommendation:{
        url:'recommendation/page',
        method:'post',
        site:5
    },
    admin_get_recommendation2:{
        url:'recommendation/list',
        method:'get',
        site:5
    },
    admin_get_recommendation_detail:{
        url:'recommendation/get',
        method:'get',
        site:5
    },
    //后台添加论文推荐
    admin_add_recommendation:{
        url:'recommendation/add',
        method:'post',
        site:5
    },
    //后台编辑论文推荐
    admin_edit_recommendation:{
        url:'recommendation/update',
        method:'post',
        site:5
    },
    //后台获取论文推荐的分类
    admin_get_thesis_cate:{
        url:'recommendation/classify/list',
        method:'get',
        site:5
    },
    //删除论文推荐
    admin_delete_recommendation:{
        url:'recommendation/delete',
        method:'get',
        site:5
    },
    recommendation_get_index:{
        url:'recommendation/topping',
        method:'get',
        site:5
    },
    recommendation_get_hot:{
        url:'recommendation/hot',
        method:'get',
        site:5
    },

    admin_get_help_cate:{
        url:'help/classify/list',
        method:'get',
        site:4
    },
    admin_add_help_cate:{
        url:'help/classify/add',
        method:'post',
        site:4
    },
    admin_edit_help_cate:{
        url:'help/classify/update',
        method:'post',
        site:4
    },
    admin_del_help_cate:{
        url:'help/classify/delete',
        method:'get',
        site:4,
    },
    admin_add_help:{
        url:'help/add',
        method:'post',
        site:4
    },
    admin_edit_help:{
        url:'help/update',
        method:'post',
        site:4
    },
    admin_del_help:{
        url:'help/delete',
        method:'get',
        site:4
    },
    admin_get_help_list:{
        url:'help/list',
        method:'get',
        site:4
    },
    get_hot_help:{
        url:'help/hot',
        method:'get',
        site:4
    },
    helper_reback:{
        url:'help/feedback/add',
        method:'post',
        site:4
    },
    helper_get_detail:{
        url:'help/detail',
        method:'get',
        site:4
    },
    reback_get_list:{
        url:'help/feedback/list',
        method:'get',
        site:4
    },

    admin_journal_del:{
        url:'lp/journal/delete',
        site:1,
        method:'get'
    },

    get_thesis_collect:{
        url:'recommendation/collection',
        site:5,
        method:'get'
    },
    get_thesis_groups:{
        url:'recommendation/grouping',
        site:5,
        method:'post'
    },

    admin_get_comments:{
        url:'backComment/commentList',
        site:2,
        method:'get'
    },
    admin_set_comment_screen:{
        url:'backComment/screenById',
        site:2,
        method:'post'
    },
    admin_set_comment_valid:{
        url:'backComment/loseById',
        site:2,
        method:'post'
    },
    adimin_del_comment:{
        url:'backComment/delComment',
        site:2,
        method:'post'
    }
}
export default CONTACT_API;